module.exports = __webpack_public_path__ + "img/logo.f04fa23f.svg";